import telegramSvg from '@/assets/icons/telegram.svg';

interface TelegramProps {
  className?: string;
}

export default function Telegram({ className = '' }: TelegramProps) {
  return (
    <img
      src={telegramSvg}
      alt="Telegram"
      className={className}
    />
  );
}
